import axios from "@/plugins/axios"
import { disableInterceptorOk } from "@/utils/HeaderNoInterceptors"

class CuponesService {

  async obtenerCupon(id: number): Promise<{ codigo: string, store_url: string }> {
    const { data } = await axios.post<{ codigo: string, store_url: string }>(`front/obtener-cupon/${id}`, disableInterceptorOk)
    return data
  }

  async hayCuponesDisponibles(id: number): Promise<boolean> {
    const { data } = await axios.get<boolean>(`front/stock-cupones/${id}`, disableInterceptorOk)
    return data
  }

  async buscarCuponPorHash(cuponId: string, hash: string): Promise<any> {
    const data = await axios.post(`/front/cupones/${cuponId}/redimir/${hash}`, disableInterceptorOk)
    return data
  }
}
export const cuponesService = new CuponesService()
